import { connect } from "react-redux";
import { weedoutDocument } from "../state/actions";
import DocumentWeedoutModalComponent from "./DocumentWeedoutModal";

const mapStateToProps = (state) => ({
  isLoading: state.documentDetails.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  weedoutDocument: (documentPid) => dispatch(weedoutDocument(documentPid)),
});

export const DocumentWeedoutModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentWeedoutModalComponent);
